import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, CtaButton } from "@/components/Bits";
import { WAFFEN } from "@/data/catalog";

const CAT_IMG =
  "https://images.unsplash.com/photo-1610165539774-791ae89d0574?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Waffen() {
  return (
    <>
      <Seo
        title="Waffen"
        description="Kurz- und Langwaffen führender Hersteller — Pistolen, Revolver, Repetierer und Selbstladebüchsen für Sport, Jagd und Behörde bei IMPEXMILTRADE GMBH in Mureck."
      />
      <PageHeader
        code="SEK-01 / Kurz- & Langwaffen"
        title="Waffen"
        sub="Vom ersten Sportgerät bis zur Jagdbüchse und Dienstpistole. Wir führen und beschaffen Kurz- und Langwaffen namhafter Hersteller — inklusive Beratung, Einschießen und Zubehörmontage."
      />

      <section className="relative border-b border-border">
        <div className="relative h-64 overflow-hidden md:h-80">
          <img src={CAT_IMG} alt="Langwaffe mit Optik" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-background/40" aria-hidden />
          <div className="blueprint-grid absolute inset-0 opacity-30" aria-hidden />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-16" data-testid="waffen-list">
        <div className="mb-8 flex items-center justify-between border-b border-border pb-4">
          <p className="mono-label text-primary">Auswahl · Modelle</p>
          <p className="mono-label text-muted-foreground">{WAFFEN.length} Positionen</p>
        </div>

        <div className="grid border-l border-t border-border md:grid-cols-2">
          {WAFFEN.map((w, i) => (
            <motion.article
              key={w.code}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 2) * 0.06 }}
              className="border-b border-r border-border p-6 transition-colors hover:bg-card"
              data-testid={`waffe-${w.code}`}
            >
              <div className="flex items-center justify-between">
                <span className="mono-label text-primary">{w.code}</span>
                <span className="mono-label text-muted-foreground">{w.type}</span>
              </div>
              <h3 className="mt-3 font-display text-2xl font-600 uppercase tracking-tight">{w.name}</h3>
              <dl className="mt-5 grid grid-cols-3 border-l border-t border-border">
                {[
                  { k: "Kaliber", v: w.caliber },
                  { k: "Kapazität", v: w.cap },
                  { k: "Einsatz", v: w.use },
                ].map((s) => (
                  <div key={s.k} className="border-b border-r border-border p-3">
                    <dt className="mono-label text-muted-foreground">{s.k}</dt>
                    <dd className="mt-1 font-mono-t text-sm text-foreground">{s.v}</dd>
                  </div>
                ))}
              </dl>
            </motion.article>
          ))}
        </div>

        <div className="mt-12 border border-border p-8 text-center">
          <p className="font-body text-muted-foreground">
            Gewünschtes Modell nicht gelistet? Wir beschaffen nahezu jede erhältliche Waffe.
          </p>
          <div className="mt-6 flex justify-center">
            <CtaButton to="/kontakt" testid="waffen-cta">
              Modell anfragen <ArrowRight size={16} />
            </CtaButton>
          </div>
        </div>
      </section>
    </>
  );
}
